module.exports = __webpack_public_path__ + "img/Pista_27.6ba7cee6.png";